module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Bag-chair-67d3272154a37a49ba278708a061f9ba.svg";